var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/** <b>Composant en mode consultation/detail d'un champ de type relate</b>*/
export default function RelateFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    var idFieldName = fieldMetadata.id_name;
    var relateId = record[idFieldName];
    var link = "".concat(process.env.PUBLIC_URL, "/modules/").concat(fieldMetadata.module, "/DetailView/").concat(relateId);
    var name = record[fieldMetadata.name] || "";
    return (_jsx(_Fragment, { children: _jsx("span", __assign({ className: "flex items-center text-blue-700 hover:text-blue-400" }, { children: _jsx("a", __assign({ href: link }, { children: name })) })) }));
}
